/* tslint:disable */
/* eslint-disable */
/**
 * Oil refinery process modeling system
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.4
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {mapValues} from '../runtime';
/**
 *
 * @export
 * @interface Target
 */
export interface Target {}

/**
 * Check if a given object implements the Target interface.
 */
export function instanceOfTarget(value: object): value is Target {
  return true;
}

export function TargetFromJSON(json: any): Target {
  return TargetFromJSONTyped(json, false);
}

export function TargetFromJSONTyped(json: any, ignoreDiscriminator: boolean): Target {
  return json;
}

export function TargetToJSON(value?: Target | null): any {
  return value;
}
